<template>
	<div style="background: white">
		<policyHeader />
		<div class="breadBox">
			<a-breadcrumb>
				<span>
					<img src="@/assets/img/position.png" />
					当前位置：
				</span>
				<a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
				<a-breadcrumb-item @click="onRollback" style="cursor:pointer">双创基地</a-breadcrumb-item>
				<a-breadcrumb-item>双创基地详情</a-breadcrumb-item>
			</a-breadcrumb>
		</div>
		<div class="tabBox">
			<div class="detailTop">
				<!-- <img v-if="detailObj.baseLogo" :src="getImg(detailObj.baseLogo)" alt="">
                <img v-else src="@/assets/img/defaultPhotoLong.png" alt=""> -->
				<a-carousel :dot-position="bottom" autoplay v-if="detailObj.picData.length > 0">
					<div class="bannerImg" v-for="(item, index) in detailObj.picData" :key="index">
						<a-image :src="getImg(item)" />
					</div>
				</a-carousel>
				<div class="bannerImgError" v-else>
					<img src="@/assets/img/defaultPhotoLong.png" alt="">
				</div>
				<div class="detailRight">
					<div class="baseName">{{ detailObj.baseName }}</div>
					<div class="baseAddress">联系电话:{{ detailObj.basePhone }}<br>地址:{{ detailObj.baseAddress }}</div>
				</div>
			</div>
			<div class="detailBottom">
				<div class="introduce">
					<div class="title">基地介绍</div>
					<div class="content" v-html="detailObj.baseDescription"></div>
				</div>
				<!-- <div class="other">
                    <div class="title">其他基地</div>
                    <div v-for="item in baseList.splice(0, 2)" :key="item.id" class="imageTitle">
                        <img v-if="item.baseLogo" :src="getImg(item.baseLogo)" alt="" @click="onImgUrl(item.id)">
                        <img v-else src="@/assets/img/defaultPhotoLong.png" alt="" @click="onImgUrl(item.id)">
                    </div>
                </div> -->
			</div>
			<div class="cardBox">
				<div class="smallCardBox">
					<!-- <div class="leftImg">
                    <img src="@/assets/img/rzqy.png" />
                  </div> -->
					<div class="rightText">入驻企业总数：<span style="color: #0048c4;">{{ detailObj.compnayCount || 0 }}</span> 家</div>
				</div>
				<a-divider style="top: 44px;height: 34px" type="vertical" />
				<div class="smallCardBox">
					<!-- <div class="leftImg">
                    <img src="@/assets/img/xzqy.png" />
                  </div> -->
					<div class="rightText">上一年总营收：<a @click="goMore('/corpBase')" style="color: #0048c4;">{{
						detailObj.operatingIncomeCount || 0
					}}</a> 万元</div>
				</div>
				<a-divider style="top: 44px;height: 34px" type="vertical" />
				<div class="smallCardBox">
					<!-- <div class="leftImg">
                    <img src="@/assets/img/xzqy.png" />
                  </div> -->
					<div class="rightText">高新技术企业数量：<span style="color: #0048c4;">{{ detailObj.highTechEnterpriseCount || 0
					}}</span>
						家
					</div>
				</div>
				<a-divider style="top: 44px;height: 34px" type="vertical" />
				<div class="smallCardBox">
					<!-- <div class="leftImg">
                    <img src="@/assets/img/dxxl.png" />
                  </div> -->
					<div class="rightText">科小数量：<span style="color: #0048c4;">{{ detailObj.technologySmesCount || 0 }}</span>
						家
					</div>
				</div>
			</div>
		</div>
		<LayoutFooter />
	</div>
</template>
<script>
import { base, volumeWeb } from "@/api/innovationService";
import { file_service } from "@/api/adminService";
import policyHeader from "./policyHeader"
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2'
export default {
	name: "policyDetail",
	components: { policyHeader, LayoutFooter },
	data() {
		return {
			detailObj: {},
			baseList: [],
			policyId: ""
		}
	},
	mounted() {
		// this.getDetail()
		this.getvolume()
		// this.getBaseList()
	},
	watch: {
		policyId(val) {
			if (val) {
				this.getDetail(this.policyId)
				// this.getBaseList()
			}

		}
	},
	created() {
		this.policyId = this.$route.query.id
		this.getDetail(this.policyId)
	},
	methods: {

		onImgUrl(id) {
			// this.$router.push({
			//     path:"/Innovation/components/policyDetail",
			//     query:{id:id}
			// })
			this.getDetail(id)
			// this.getBaseList()
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},
		getDetail(id) {
			this.getAction({
				url: base.detail,
				params: { id: id }
			}).then(res => {
				this.detailObj = {
					...res,
					picData: res.baseImage ? res.baseImage.split(',') : []
				}
				console.log(this.detailObj, 'detailObj')
			})
		},
		getBaseList() {
			this.getAction({
				url: base.pageList,
			}).then(res => {
				this.baseList = res.records
			})
		},
		getvolume() {
			this.postAction({
				url: volumeWeb.saveVisits,
				params: {
					type: 3,
					name: "innovation"
				}
			})
		},
		onRollback() {
			this.$router.push({
				path: "/Innovation/components/policyCenter",
				query: {
					type: "双创基地"
				}
			})
		},
		onRollbackHome() {
			this.$router.push({
				path: "/Innovation/index",
				query: {
					type: "首页"
				}
			})
		}
	}
}
</script>
<style scoped lang="less">
.breadBox {
	width: 1200px;
	margin: 0 auto;
	padding: 20px 0;
	background: white;
}

.tabBox {
	width: 1200px;
	margin: 0 auto;
	padding: 10px 0 20px 0;

	.detailTop {
		background: #edf0f7;
		padding: 20px;
		display: flex;

		.bannerImgError {
			width: 304px;
			height: 171px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.ant-carousel {
			width: 304px;
			height: 171px;

			.bannerImg {
				width: 100%;
				height: 171px;

				:deep(.ant-image) {
					width: 100%;
					height: 100%;
				}

				:deep(.ant-image-img) {
					width: 100%;
					height: 100%;
				}
			}
		}

		.detailRight {
			margin-left: 30px;
			padding-top: 40px;

			.baseName {
				font-size: 20px;
			}

			.baseAddress {
				font-size: 14px;
				color: #666;
				margin-top: 30px;
			}
		}
	}

	.detailBottom {
		display: flex;
		margin: 20px 0;
		justify-content: space-between;

		.introduce {
			width: 100%;

			.title {
				width: 70px;
				font-size: 16px;
				border-bottom: 2px solid #2162e4;
				font-weight: 800;
			}

			.content {
				font-size: 16px;
				line-height: 30px;
				margin-top: 20px;
				text-indent: 30px;
				min-height: 200px;
			}
		}

		// .other {
		//     width: 27%;

		//     .title {
		//         width: 70px;
		//         font-size: 16px;
		//         border-bottom: 2px solid #2162e4;
		//         font-weight: 800;
		//     }

		//     .imageTitle {
		//         margin-top: 20px;

		//         img {
		//             width: 304px;
		//             height: 171px;
		//         }
		//     }
		// }
	}

	.cardBox {
		display: flex;
		justify-content: space-between;
		width: 1200px;
		height: auto;
		margin: 0 auto;
		background-color: #edf0f7;

		.smallCardBox {
			margin: 36px auto;
			height: 46px;

			.leftImg {
				float: left;
				width: 46px;
				height: 46px;
				border-radius: 50%;
			}

			.rightText {
				float: left;
				margin-left: 5px;
				line-height: 46px;

				a,
				span {
					font-size: 24px;
					color: #0048c4;
				}
			}
		}
	}
}
</style>
